/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Title1Inputs */

const id_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman tidak ditemukan`)
};

const ms_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman tidak ditemui`)
};

const da_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siden blev ikke fundet`)
};

const de_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite nicht gefunden`)
};

const en_us2_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

const es_es2_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página no encontrada`)
};

const es_mx2_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página no encontrada`)
};

const fil_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang pahina`)
};

const fr_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page non trouvée`)
};

const it_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina non trovata`)
};

const hu_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az oldal nem található`)
};

const nl_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina niet gevonden`)
};

const no_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siden ble ikke funnet`)
};

const pl_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona nie znaleziona`)
};

const pt_br2_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página não encontrada`)
};

const pt_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página não encontrada`)
};

const ro_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagină negăsită`)
};

const fi_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sivua ei löydy`)
};

const sv_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidan hittades inte`)
};

const vi_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy trang`)
};

const tr_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfa bulunamadı`)
};

const cs_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stránka nenalezena`)
};

const bg_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страницата не е намерена`)
};

const ru_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница не найдена`)
};

const uk_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сторінку не знайдено`)
};

const ar_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة غير موجودة`)
};

const hi_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेज नहीं मिला`)
};

const th_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบหน้า`)
};

const ja_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページが見つかりません`)
};

const zh_cn2_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面未找到`)
};

const zh_hant1_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`頁面未找到`)
};

const ko_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Notfound_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notfound_title1 = /** @type {((inputs?: Notfound_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notfound_title1(inputs)
	if (locale === "ms") return ms_notfound_title1(inputs)
	if (locale === "da") return da_notfound_title1(inputs)
	if (locale === "de") return de_notfound_title1(inputs)
	if (locale === "en-US") return en_us2_notfound_title1(inputs)
	if (locale === "es-ES") return es_es2_notfound_title1(inputs)
	if (locale === "es-MX") return es_mx2_notfound_title1(inputs)
	if (locale === "fil") return fil_notfound_title1(inputs)
	if (locale === "fr") return fr_notfound_title1(inputs)
	if (locale === "it") return it_notfound_title1(inputs)
	if (locale === "hu") return hu_notfound_title1(inputs)
	if (locale === "nl") return nl_notfound_title1(inputs)
	if (locale === "no") return no_notfound_title1(inputs)
	if (locale === "pl") return pl_notfound_title1(inputs)
	if (locale === "pt-BR") return pt_br2_notfound_title1(inputs)
	if (locale === "pt") return pt_notfound_title1(inputs)
	if (locale === "ro") return ro_notfound_title1(inputs)
	if (locale === "fi") return fi_notfound_title1(inputs)
	if (locale === "sv") return sv_notfound_title1(inputs)
	if (locale === "vi") return vi_notfound_title1(inputs)
	if (locale === "tr") return tr_notfound_title1(inputs)
	if (locale === "cs") return cs_notfound_title1(inputs)
	if (locale === "bg") return bg_notfound_title1(inputs)
	if (locale === "ru") return ru_notfound_title1(inputs)
	if (locale === "uk") return uk_notfound_title1(inputs)
	if (locale === "ar") return ar_notfound_title1(inputs)
	if (locale === "hi") return hi_notfound_title1(inputs)
	if (locale === "th") return th_notfound_title1(inputs)
	if (locale === "ja") return ja_notfound_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_notfound_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notfound_title1(inputs)
	return ko_notfound_title1(inputs)
});
export { notfound_title1 as "notFound.title" }